import { useEffect, useState } from 'react';
import { Router } from './router.js';
import { useSession } from './hooks/useSession.js';
import { Login } from './pages/Login.js';
import { SettingsEffects } from './components/SettingsEffects.js';
import { ToastRegion } from './components/Toast.js';

export function App() {
  const { session, loading, refresh } = useSession();
  const [route, setRoute] = useState(window.location.pathname + window.location.search);

  useEffect(() => {
    const handler = () => setRoute(window.location.pathname + window.location.search);
    window.addEventListener('popstate', handler);
    return () => window.removeEventListener('popstate', handler);
  }, []);

  if (loading) return <div className="boot">Loading…</div>;
  if (!session) {
    return (
      <>
        <Login onLoggedIn={refresh} />
        <ToastRegion />
      </>
    );
  }

  return (
    <>
      <SettingsEffects />
      <Router currentPath={route} onNavigate={(p) => { window.history.pushState({}, '', p); setRoute(p); }} />
      <ToastRegion />
    </>
  );
}
